// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1736234150942
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/assets/sheets/main.css
// module id = ./src/assets/sheets/main.css
// module chunks = 0